import {register} from '@shopify/theme-sections';

import $ from 'jquery';

register('subscription-header', {

  onLoad() {
    this.$container = $(this.container);
    this.namespace = `.${this.id}`;

      // When a completed step is clicked in the checkout flow nav bar, go back to that step
    $(document).on('click', '.flow-nav', (e) => {
      e.preventDefault();

      const classes = e.currentTarget.classList;

      if (classes.contains('complete')) {

        const step = e.currentTarget.dataset.step;
        const flow = window.mosaic.views.state.flow;

        if (classes.contains('flow-nav-step-meal-menu')) {

            /**
             * GTM - editProducts
             */
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'editProducts',
          });
        }

        window.mosaic.views.nextStep(flow, step);
      }
    });

  },
});
